import { render, staticRenderFns } from "./agGridForm.vue?vue&type=template&id=68003060&"
import script from "./agGridForm.vue?vue&type=script&lang=js&"
export * from "./agGridForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports